/**
 * Outreach entry — Campaign Dashboard (API-backed).
 * Kept as default export for existing App.js imports.
 */
export { default } from "./campaignDashboard/CampaignDashboardPage";
